import styled from 'styled-components';

export const Container = styled.div`
  
`;

export const Content = styled.div`
  margin-top: 10px;
  /* border: 1px solid #D3D3D3; */
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 8px;
  background: #fff;
`;

export const Form = styled.form`
  legend {
    font-family: 'Inter';
    font-size: 20px;
    margin-bottom: 20px;
  }

  .check-box {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
      color: #333;
    }
    .MuiFormControlLabel-root {
      margin-right: 0;
    }
    .css-ahj2mt-MuiTypography-root {
      font-family: 'Inter';
      font-weight: 500;
      color: #333;
      font-size: 15px;

    }

  }
  .input-group:not(:last-child) {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }

  .input-group.tripple {
    display: flex;
    flex-direction: column;

    @media(min-width: 600px) {
      flex-direction: row;
    }
  }

  .input-wrapper {
    width: 100%;
    .input {
        background: #fff;
        width: 100%;
    }

  }
  .hook-error {
    color: #f7345b;
    font-family: 'Inter';
    font-size: 14px;
  }
  
  .text-area {
    width: 100%;
    outline: none;
    min-height: 80px;
    border: 1px solid #D3D3D3;
    border-radius: 6px;
    padding: 6px;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    color: #333;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
  }
`;